module.exports = __webpack_public_path__ + "img/19-mob.1b803f55.svg";